import * as R from 'remeda';
import { Link as RouterLink } from 'react-router-dom';
import { DocumentBlocker } from '@rossum/api-client/queues';
import { Link as MuiLink, Stack, Typography } from '@rossum/ui/material';
import { generateDocumentListUrl } from '../../../../../document-list-base/helpers/generateDocumentListUrl';
import { getLimitedAnnotationIds } from '../../utils';

type RenderBlockedDocumentCountsProps = {
  blockers: DocumentBlocker[];
  queueId: number;
};

export const RenderBlockedDocumentCounts = ({
  blockers,
  queueId,
}: RenderBlockedDocumentCountsProps) => {
  const blockedDocumentIds = R.pipe(
    blockers,
    R.flatMap(b => b.exampleAnnotationIds),
    R.unique()
  );

  const limitedAnnotationIds = getLimitedAnnotationIds(blockedDocumentIds);

  const totalCount = R.sum(blockers.map(b => b.documentCount));

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        justifyContent: 'flex-end',
        flex: 1,
        height: '100%',
        alignItems: 'center',
      }}
      useFlexGap
    >
      {limitedAnnotationIds.length > 0 ? (
        <MuiLink
          component={RouterLink}
          color="text.primary"
          sx={{ flex: 0.2, textAlign: 'right' }}
          to={generateDocumentListUrl({
            filtering: [
              {
                field: 'queue',
                operator: 'isAnyOf',
                value: [queueId],
              },
              {
                field: 'annotation',
                operator: 'isAnyOf',
                value: limitedAnnotationIds,
              },
            ],
            level: 'queue',
            view: 'documents',
          })}
        >
          {totalCount}
        </MuiLink>
      ) : (
        <Typography sx={{ flex: 0.2, textAlign: 'right' }}>
          {totalCount}
        </Typography>
      )}
    </Stack>
  );
};
